/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-12-08 10:59:09
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_change\src\api\smart\specialmaterial\shiplist.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/intelligent/materials/shipping/queryPage'
export const batchUpdateOrDelete = '/icps'
export const saveOrUpdate = '/icps'
// export function carMaintainsave(data) {
//   return request({
//     url: '/icps/system/sign/basics/carMaintain/save',
//     method: 'post',
//     data
//   })
// }
/**批量审核 */
export function auditConsiment(data) {
    return request({
      url: '/icps/system/sign/intelligent/materials/shipping/auditConsiment',
      method: 'post',
      data
    })
  }
  /**补录 */
export function additionalRecording(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/shipping/additionalRecording',
    method: 'post',
    data
  })
}
/**批量取消审核 */
export function cancelAuditConsiment(data) {
    return request({
      url: '/icps/system/sign/intelligent/materials/shipping/cancelAuditConsiment',
      method: 'post',
      data
    })
  }
/**冲销 */
export function backWeight(data) {
    return request({
      url: '/icps/system/sign/intelligent/materials/shipping/backWeight',
      method: 'post',
      data
    })
  }
  /**
 * @Description: 删除
 */
 export function deleteTask(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/shipping/deleteTask',
    method: 'get',
    params
  })
}